/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState } from 'react';
import { Tooltip, ClickAwayListener, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

import InfoIcon from '../../public/icons/info-icon.svg';
import { RootState } from '../../store/reducers';

type Props = {
  detailed_conversations: number;
  high_intent_contacts: number;
};

const useStyles = makeStyles({
  touch: {
    fontSize: '0.55rem',
  },
  tooltip: {
    fontSize: '0.75rem',
  },
});

const DetailedConvesrationsMetrics = (props: Props) => {
  const classes = useStyles();
  const { postCallEmailPreferences } = useSelector((state:RootState) => state.common);
  const {
    detailed_conversations,
    high_intent_contacts,
  } = props;
  const [showDetailedConversationsTooltip, setShowDetailedConversationsTooltip] = useState<boolean>(false);
  const [showHighIntentContactsTooltip, setShowHighIntentContactsTooltip] = useState<boolean>(false);

  const handleDetailedConversationsClick = () => {
    setShowDetailedConversationsTooltip(!showDetailedConversationsTooltip);
  };

  const handleHighIntentContactsClick = () => {
    setShowHighIntentContactsTooltip(!showHighIntentContactsTooltip);
  };

  let criteria = '';
  if (postCallEmailPreferences?.detailed_conversation_type === 'minutes') 
    criteria = `${postCallEmailPreferences?.detailed_conversation_duration} minutes`;
  else
    criteria = `${postCallEmailPreferences?.detailed_conversation_wordcount} words`;

  return (
    <div className="relative flex flex-col px-4 py-1 bg-background-white w-full max-w-xs min-w-[280px] lg:min-w-max rounded">
      <div className="flex items-center mb-6 mt-2"> 
        <p className="text-sm leading-5 font-bold text-primary-grey ml-2">
          Detailed Conversations
        </p>
        <ClickAwayListener onClickAway={() => setShowDetailedConversationsTooltip(false)}>
          <div
            className="inline ml-1 mb-2"
            onMouseOver={
              isMobile
                ? () => {}
                : () => setShowDetailedConversationsTooltip(true)
            }
            onMouseLeave={
              isMobile
                ? () => {}
                : () => setShowDetailedConversationsTooltip(false)
            }
          >
            <Tooltip
              title={`Detailed calls are where a minimum of ${criteria} are spoken.`}
              placement="bottom-end"
              arrow
              open={showDetailedConversationsTooltip}
              classes={{
                touch: classes.touch,
                tooltip: classes.tooltip,
              }}
              leaveDelay={1000}
              leaveTouchDelay={1000}
            >
              <button
                type="button"
                className="h-7 lg:h-5 w-7 lg:w-5 p-0 bg-transparent rounded-full cursor-pointer"
                onClick={handleDetailedConversationsClick}
              >
                <InfoIcon className="w-4 h-4 text-primary-grey fill-current cursor-pointer" />
              </button>
            </Tooltip>
          </div>
        </ClickAwayListener>
        <span className="text-xl font-bold ml-2">
          {Math.round(Number(detailed_conversations))}%
        </span>
      </div>
      <div className="flex items-center mb-2">
        <p className="text-sm leading-5 font-bold text-primary-grey ml-2">
          High Intent Contacts
        </p>
        <ClickAwayListener onClickAway={() => setShowHighIntentContactsTooltip(false)}>
          <div
            className="inline ml-1 mb-2"
            onMouseOver={
              isMobile
                ? () => {}
                : () => setShowHighIntentContactsTooltip(true)
            }
            onMouseLeave={
              isMobile
                ? () => {}
                : () => setShowHighIntentContactsTooltip(false)
            }
          >
            <Tooltip
              title="The high intent percentage is calculated using only those customers with whom at least one detailed conversation has taken place"
              placement="bottom-end"
              arrow
              open={showHighIntentContactsTooltip}
              classes={{
                touch: classes.touch,
                tooltip: classes.tooltip,
              }}
              leaveDelay={1000}
              leaveTouchDelay={1000}
            >
              <button
                type="button"
                className="h-7 lg:h-5 w-7 lg:w-5 p-0 bg-transparent rounded-full cursor-pointer"
                onClick={handleHighIntentContactsClick}
              >
                <InfoIcon className="w-4 h-4 text-primary-grey fill-current cursor-pointer" />
              </button>
            </Tooltip>
          </div>
        </ClickAwayListener>
        <span className="text-xl font-bold ml-2">
          {Math.ceil(Number(high_intent_contacts))}%
        </span>
      </div>
    </div>
  );
};

export default DetailedConvesrationsMetrics;